import isVerifyTokenGuard from "@/guards/verifyTokenGuard";

export default {
    name: 'catalog-clues',
    component: () => import(/* webpackChunkName: "base-layout" */ '@/layouts/BaseLayout.vue'),
    children: [
        {
            path: '',
            name: 'catalog-clues-index',
            beforeEnter: [isVerifyTokenGuard],
            meta: {
                breadcrumbs: [
                                        {
                        transKey: 'breadcrumbs.official-catalogs',
                        isActive: false
                    },
                    {
                        transKey: 'breadcrumbs.catalog-clues-index',
                        isActive: true
                    }
                ]
            },
            component: () => import(/* webpackChunkName: "catalog-clues-index" */ '@/modules/configurations/catalogs/catalog-clues/views/Index.vue')
        }
    ]
}
